import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { customerUpdate } from "../../../services/CustomerInfo/EditCustomer";
import { Dropdown } from "primereact/dropdown";
import { getLocalChargesAndDiscount } from "../../../utils/localStorage";

export default function EditCustomerChargeModal({
  setEditCustomerChargeModalVisible,
  editCustomerChargeModalVisible,
  chargeName,
  discountName,
  chargeDiscountType,
  editCustomerData,
  storeId,
  sendDataToEditCustomer
}) {
  const navigate = useNavigate();

  const [chargeDiscountValue, setChargeDiscountValue] = useState(chargeDiscountType === "Charge" ? chargeName : discountName);
  const [chargeError, setChargeError] = useState("");
  const [chargeItems, setChargeItems] = useState([]);

  const [charges, setCharges] = useState([]);
  const [discounts, setDiscounts] = useState([]);

   const fetchLocalChargesAndDiscount = async () => {
      const { chargesAndDiscount } = getLocalChargesAndDiscount();
      if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
        const [chargeArray, discountArray] = chargesAndDiscount.reduce(
            ([charges, discounts], item) => {
              if (
                item.chargeDiscountMode === 'ALL' ||
                item.chargeDiscountMode === 'BOOKING'
              ) {
                if (item.chargeDiscountType === 'CHARGE') charges.push(item);
                if (item.chargeDiscountType === 'DISCOUNT')
                  discounts.push(item);
              }
              return [charges, discounts];
            },
            [[], []],
          );


          setCharges(chargeArray);
          setDiscounts(discountArray);
      } else {
        setCharges([]);
        setDiscounts([]);
      }
    };

  const addChargesData = [
    ...charges.map((item, index) => ({
      name: item.name,
      value: item.id,
    })),
    {
      name: 'none',
      value: 0,
    },
  ];

  const addDiscountsData = [
    ...discounts.map((item, index) => ({
      name: item.name,
      value: item.id,
    })),
    {
      name: 'none',
      value: 0,
    },
  ];

  const chargeDiscountTypeList = chargeDiscountType === "Charge" ? addChargesData : addDiscountsData ;


  const chargeDiscountValueCal = chargeDiscountType === 'Charge' ? chargeName : discountName;


  const addChargeDataNew = chargeDiscountTypeList.filter(
    item => chargeDiscountValueCal === item.value,
  );

  useEffect(() => {
    if(addChargeDataNew[0]?.value !== null) {
      setChargeDiscountValue(addChargeDataNew[0]?.value);
    }
  }, [addChargeDataNew[0]?.value]);
 
  useEffect(() => {
    fetchLocalChargesAndDiscount();
  }, []);

  const handleEditData = async () => {
    // Create a new edited field object
    
    // Update the specific field in editCustomerData
    let updatedData = { ...editCustomerData };
     
      if(chargeDiscountType === 'Charge') {
        updatedData.autoChargeId = chargeDiscountValue?.name === 'None' ? chargeDiscountValue?.value : chargeDiscountValue;
      } else {
        updatedData.autoDiscountId = chargeDiscountValue?.name === 'None' ? chargeDiscountValue?.value : chargeDiscountValue;
      }
     
    // Add more conditions for other fields
    try {
      const response = await customerUpdate(updatedData);
      if (!response.data.error) {
        const Res = response.data;
        const message = Res.message;
        const status = Res.status;

        // Close the modal
        setEditCustomerChargeModalVisible(false);
        sendDataToEditCustomer({
          success: true,
        });
        if (status === true) {
          setModalVisible(true);
          setModalStatus("success");
          setModalText(message);
        } else {
          setModalVisible(true);
          setModalStatus("not Success");
          setModalText(message);
        }
        // if (Res) {
        //   sendDataToEditCustomer({
        //     success: true,
        //   });
        // }
      }
    } catch (error) {
      console.error("Error:", error);
    }

    // Close the modal
    setEditCustomerChargeModalVisible(false);
  };

  useEffect(() => {
    // When the fieldNameName or fieldNameValue changes, update the editValue
    if (
      chargeDiscountValue !== null
    ) {
      setChargeDiscountValue(chargeDiscountValue);
    }
  }, [chargeDiscountValue]);

  //         //

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setEditCustomerChargeModalVisible(false);
    // setEditValue
    // setEditLastNameValue
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={editCustomerChargeModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!editCustomerChargeModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-user"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Edit {chargeDiscountType}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="mx-4">
            <Dropdown
                id="chargeDiscountValue"
                value={chargeDiscountValue}
                onChange={(e) => {setChargeDiscountValue(e.value);setChargeError("")}}
                options={chargeDiscountTypeList}
                optionLabel="name"
                placeholder={chargeDiscountType}
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {chargeError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {chargeError}
                </p>
              )}
            </div>

            <Button
              onClick={handleEditData}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
